import React from 'react';
import { faShieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  firstName: string;
};

export const SitterTitle = ({ firstName }: Props): JSX.Element => (
  <div className='flex flex-row'>
    <span className='text-left text-xl font-semibold whitespace-nowrap overflow-hidden text-ellipsis'>
      {firstName}
    </span>
    <FontAwesomeIcon icon={faShieldCheck} className='text-kiwi-700 ml-2 text-lg self-center' />
  </div>
);
